module.exports = __webpack_public_path__ + "img/pic3.364de044.png";